module.exports = __webpack_public_path__ + "assets/img/Main material (16).08218d84.jpg";